const tempKey = '89fd2a4fe9f385a3bc60fd404e9e4192';
const tempAppId = '2P8K2UAGEG';
let tempIndex = 'dev_porter';

if (window.location.hostname === 'app.getporter.io') {
  tempIndex = 'prod_PORTER';
}

export const API_KEY = tempKey;
export const APP_ID = tempAppId;
export const INDEX = tempIndex;
